export default "__VITE_ASSET__BsiKjWVa__"